import { Component } from '@angular/core';
import { ShowComponent } from 'src/app/common/component/show.component';

@Component({
	selector: 'app-resident-trip-reservation',
	templateUrl: './resident-trip-reservation.component.html',
	styleUrls: ['./resident-trip-reservation.component.css'],
})
export class ResidentTripReservationComponent extends ShowComponent {
	protected parentComponent = 'resident/residentTripsReservation';
	protected apiUrl = 'resident/residentTripsReservation/';
	protected apiUrlAdd = '/resident/residentTripsReservation/';
	protected itemsBeforeDataLoad = 4;
	filters;
	parameters = {
		destinations: [],
	};
	people: Array<any> = [];
	years = null;
	isZero = null;
	amount = {
		adult: 0,
		child: 0,
		priceEUR: 0,
		priceHR: 0,
	};
	private readonly calculate = {
		priceAdultEur: 0,
		priceAdultHr: 0,
		priceChildEur: 0,
		priceChildHr: 0,
	};
	trips: Array<any> = [];
	comment: string;
	selectedTrip: Array<any> = [];
	selectedPerson: Array<any> = [];

	protected loadBefore() {
		this.api.get('/resident/residentPeopleList/', (result, error) => {
			this.people = result.data;
			this.loadData();
		});
		this.api.get('/resident/residentTripDepartures/', (result, error) => {
			this.trips = result.data;
			this.loadData();
		});
		this.api.get('/bag/bagLocations/', (result, error) => {
			this.parameters.destinations = result.data.filter((obj) => ['11', '12', '143', '144'].includes(obj.id));
		});
	}

	calculated() {
		let trip;
		this.selectedTrip.forEach((id) => (trip = this.trips.find((objFind) => objFind.id == id)));
		this.amount.priceEUR = 0;
		this.amount.priceHR = 0;
		this.amount.adult = 0;
		this.amount.child = 0;
		this.selectedPerson.forEach((obj) => {
			const person = this.people.filter((objFind) => objFind.personId == obj);
			this.calculateDateBirth(person);
			if (!trip) {
				return;
			}
			if (this.years >= trip.discountAge) {
				this.amount.adult++;
				this.calculatePrice('adult');
			} else {
				this.amount.child++;
				this.calculatePrice('child');
			}
		});
		this.amount.priceEUR = +this.amount.priceEUR.toFixed(2);
		this.amount.priceHR = +this.amount.priceHR.toFixed(2);
	}

	protected calculateDateBirth(person) {
		this.years = 0;
		person.forEach((obj) => {
			const ageDifMs = Date.now() - new Date(obj.birthDate).getTime();
			const ageDate = new Date(ageDifMs);
			this.years = Math.abs(ageDate.getUTCFullYear() - 1970);
		});
	}

	protected calculatePrice(personType: string) {
		this.calculate.priceChildEur = 0;
		this.calculate.priceChildHr = 0;
		this.calculate.priceAdultEur = 0;
		this.calculate.priceAdultHr = 0;
		if (this.isZero) {
			return;
		}
		this.selectedTrip
			.map((tripId) => {
				return this.trips.find((objFind) => objFind.id == tripId);
			})
			.forEach((obj) => {
				switch (personType) {
					case 'child':
						this.calculate.priceChildEur +=
							obj.priceEuro * 1 * (obj.discountValue / 100) +
							obj.surchargeEUR * 1 * (obj.discountValue / 100);
						this.calculate.priceChildHr +=
							obj.priceHr * 1 * (obj.discountValue / 100) +
							obj.surchargeHR * 1 * (obj.discountValue / 100);
						break;
					case 'adult':
						this.calculate.priceAdultEur += obj.priceEuro * 1 + obj.surchargeEUR * 1;
						this.calculate.priceAdultHr += obj.priceHr * 1 + obj.surchargeHR * 1;
						break;
				}
			});
		this.amount.priceEUR += this.calculate.priceAdultEur + this.calculate.priceChildEur;
		this.amount.priceHR += this.calculate.priceChildHr + this.calculate.priceAdultHr;
	}

	submit() {
		let count = 0;
		this.selectedTrip.forEach((obj) => {
			count += 1;
		});
		if (count > 1 && this.amount.child) {
			this.infobox.error('Załóż osobne rezerwacje jeżeli w zakupie wycieczki uwzględniono dziecko');
			return;
		}
		this.loader.show();
		const data = {
			id: this.uuid.generate(),
			priceEUR: this.amount.priceEUR,
			priceHR: this.amount.priceHR,
			status: null,
			isZero: this.isZero ? 1 : 0,
			amountChild: this.amount.child,
			createdBy: null,
			amountAdult: this.amount.adult,
			comment: this.comment,
			personId: this.selectedPerson,
			residentReservation: this.selectedTrip,
			residentTripsId: this.selectedTrip
				.map((tripId) => {
					return this.trips.find((objFind) => objFind.id == tripId).residentTripsId;
				})
				.reduce(function (a, b) {
					if (a.indexOf(b) < 0) a.push(b);
					return a;
				}, []),
		};
		this.api.post('/resident/residentTripsReservation/', data, (result, error) => {
			this.loader.hide();
			if (!error) {
				this.router.navigate(['/residentTrips/documents/ticket/' + data.id]);
			} else {
				return;
			}
		});
	}
}
